import { DndContext, closestCenter, KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";

// Wraps a list so its children (using useSortable) can be dragged. Calls onReorder(newIds) after a drop.
export const SortableArea = ({ ids, onReorder, strategy = verticalListSortingStrategy, children }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 4 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
  const onDragEnd = ({ active, over }) => {
    if (over && active.id !== over.id) onReorder(arrayMove(ids, ids.indexOf(active.id), ids.indexOf(over.id)));
  };
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <SortableContext items={ids} strategy={strategy}>{children}</SortableContext>
    </DndContext>
  );
};

// Merges a reordered subset back into the full list, keeping the subset's slots.
export const mergeOrder = (all, subsetIds) => {
  const set = new Set(subsetIds);
  const byId = Object.fromEntries(all.map((x) => [x.id, x]));
  let k = 0;
  return all.map((x) => (set.has(x.id) ? byId[subsetIds[k++]] : x));
};
